const initialState = () => ({
  loading: false,
  data: {},
  nurses: null,
  speechTherapists: null,
  doctors: null
});

const ACTION_KEY = 'PATIENT_DETAIL';

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${ACTION_KEY}_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }
    case `${ACTION_KEY}_REJECTED`: {
      return {
        ...state,
        loading: false
      };
    }
    case `${ACTION_KEY}_FULFILLED`: {
      return {
        ...state,
        loading: false,
        data: action.payload
      };
    }
    case `${ACTION_KEY}_NURSES_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }
    case `${ACTION_KEY}_NURSES_REJECTED`: {
      return {
        ...state,
        loading: false
      };
    }
    case `${ACTION_KEY}_NURSES_FULFILLED`: {
      return {
        ...state,
        loading: false,
        nurses: action.payload
      };
    }
    case `${ACTION_KEY}_DOCTORS_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }
    case `${ACTION_KEY}_DOCTORS_REJECTED`: {
      return {
        ...state,
        loading: false
      };
    }
    case `${ACTION_KEY}_DOCTORS_FULFILLED`: {
      return {
        ...state,
        loading: false,
        doctors: action.payload
      };
    }
    case `${ACTION_KEY}_SPEECH_THERAPISTS_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }
    case `${ACTION_KEY}_SPEECH_THERAPISTS_REJECTED`: {
      return {
        ...state,
        loading: false
      };
    }
    case `${ACTION_KEY}_SPEECH_THERAPISTS_FULFILLED`: {
      return {
        ...state,
        loading: false,
        speechTherapists: action.payload
      };
    }
    case `${ACTION_KEY}_DISCONNECT_NURSE_FULFILLED`: {
      const { nurseId } = action.payload;
      const nurses = state.nurses.filter(row => row.nurseId !== nurseId);
      return {
        ...state,
        loading: false,
        nurses
      };
    }
    case `${ACTION_KEY}_CONNECT_NURSE_FULFILLED`: {
      const nurses = state.nurses;
      nurses.push(action.payload);
      return {
        ...state,
        loading: false,
        nurses
      };
    }
    case `${ACTION_KEY}_DISCONNECT_DOCTOR_FULFILLED`: {
      const { doctorId } = action.payload;
      const doctors = state.doctors.filter(row => row.doctorId !== doctorId);
      return {
        ...state,
        loading: false,
        doctors
      };
    }
    case `${ACTION_KEY}_CONNECT_DOCTOR_FULFILLED`: {
      const doctors = state.doctors;
      doctors.push(action.payload);
      return {
        ...state,
        loading: false,
        doctors
      };
    }
    case `${ACTION_KEY}_RESET`: {
      return initialState();
    }
    default:
      return state;
  }
};

export default reducer;
